var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgentFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 6H4V9.171L12 17.171V26H16V24H18V26C18 27.105 17.105 28 16 28H12C10.895 28 10 27.105 10 26V17.999L2.586 10.585C2.211 10.21 2 9.701 2 9.171V6C2 4.895 2.895 4 4 4H26V6Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 13.5902L24.414 12.0042L26 10.4182L27.586 12.0042L26 13.5902ZM19.586 20.0042H18V18.4182L23 13.4182L24.586 15.0042L19.586 20.0042ZM29.707 11.2972L26.707 8.29716C26.316 7.90616 25.684 7.90616 25.293 8.29716L16 17.5902V22.0042H20.414L29.707 12.7112C30.098 12.3202 30.098 11.6882 29.707 11.2972Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentFilter);
export default __webpack_public_path__ + "static/media/agent-filter.2b77b7a96a5192bbc19d07d0ffa16f5a.svg";
export { ForwardRef as ReactComponent };